import React from 'react'

const IntersectionContext = React.createContext({inView: true})

export default IntersectionContext